module.exports = __webpack_public_path__ + "static/media/Mask.def72897.png";